NtechApp.Features = function($view) {
    var me = this;

    this._$view = null;
    this._touchClickEvent = null;

    this._grid = null;

    this._css = {
        ids: {
        },

        classes: {
        },

        data: {
        }
    }

    this._construct = function () {
        me._$view = $view;
        me._touchClickEvent = new NtechApp.TouchClickEvent();

        setTimeout(function() {
            if(me._$view.length == 0)
                return;

            me._createGrid();
            me._bindEvents();
        }, 200);
    }

    this._bindEvents = function () {
        $(window).on(NtechApp.Features.EVENT_WINDOW_RESIZE, function() {
            //if($(window).width() > 610)
            //    me._grid.setFilter("all");
            //else
            //    me._grid.setFilter("onlyVisible");
        });

        $(document).on(NtechApp.Features.EVENT_DOCUMENT_SCROLL, function() {
            me._grid.silentRender(me._grid.getSilent(true));
        });
    }

    this._unbindEvents = function () {
        $(window).off(NtechApp.Features.EVENT_WINDOW_RESIZE);
        $(document).off(NtechApp.Features.EVENT_DOCUMENT_SCROLL);
    }

    this.destruct = function () {
        me._grid.destruct();

        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.Features.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Features";
NtechApp.Features.EVENT_WINDOW_RESIZE = "resize.NtechApp.Features";

NtechApp.Features.prototype._createGrid = function() {
    var isMobile = bowser.mobile || bowser.tablet;
    this._grid = new Gridifier(this._$view.find(".grid"), {
        class: "gridItem",
        loadImages: true,
        intersections: false,
        toggle: (!isMobile) ? "rotateZWithFade" : "scaleWithFade",
        filter: {
            selected: "all",

            all: function(item) {
                return true;
            },

            onlyVisible: function(item) {
                return !$(item).hasClass("bgItem");
            }
        }
    });

    var me = this;
    this._grid.onReposition(function() {
        me._grid.silentRender(me._grid.getSilent(true));
    });

    this._grid.silentAppend(this._grid.collectNew());
};